import React from 'react';

// Normalize names like "QC (control qualité)" -> "qc-control-qualite"
const normalizeSlug = (str) =>
  String(str || '')
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[()[\]]/g, '') // remove parentheses and brackets (no useless escapes)
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

const registry = {
  'aquila-series': React.lazy(() => import('./AquilaSeriesDetails')),
  'qc-series': React.lazy(() => import('./QCSeriesDetails')),
  'flake-analyzer': React.lazy(() => import('./FlakeAnalyserDetails')),
    'flake-sorter': React.lazy(() => import('./FlakeSorterDetails')),
};

// Optional aliases pointing to the same component
const aliases = {
  'qc': 'qc-series',
  'qc-control-qualite': 'qc-series',
  'qc-control-qualite-': 'qc-series',
};

export const resolveProductKey = (slugOrName) => {
  const s = normalizeSlug(slugOrName);
  return aliases[s] || s;
};

export const getProductComponent = (slugOrName) => {
  const key = resolveProductKey(slugOrName);
  return registry[key];
};